import React from "react";
import { ReactComponent as Stars } from "assets/svgs/yellow-stars.svg";
import Link from "helpers/link";
import { useGlobalContext } from "context/global";
import clsx from "clsx";

const ReviewsSnippet = ({ leftAlign, reviewsLink, type = "store" }) => {
	const { translation, reviews } = useGlobalContext();
	const reviewStats = reviews?.[type];

	if (!reviewStats) return null;

	return (
		<div className={clsx("my-3 inline-flex flex-row", leftAlign ? "justify-start" : "justify-center")}>
			<Stars className="w-20 h-4"/>
			<p className="ml-1 text-sm">
				<strong className="mr-1">{reviewStats?.average}</strong>
				<Link to={reviewsLink}>
					({reviewStats?.total?.toLocaleString("de-DE")} {translation?.other?.reviews})
				</Link>
			</p>
		</div>
	);
};

export default ReviewsSnippet;